import { $, $$ } from '@/utilities/helpers';

const scrollElements = $$('.js-scroll-element');

scrollElements.forEach((scrollElement) => {
    const elements = scrollElement.querySelectorAll('.scroll-element__element');
    const items = scrollElement.querySelectorAll('.scroll-element__item');
    const navItems = scrollElement.querySelectorAll('.scroll-element__nav__item');
    const ticks = scrollElement.querySelectorAll('.scroll-element__ticks__tick');
    let lastScrollY = window.scrollY;

    function updateActiveOnScroll() {
        let activeIndex = -1;
        const viewportCenter = window.innerHeight / 2;

        elements.forEach((el, index) => {
            const rect = el.getBoundingClientRect();
            const elCenter = rect.top + rect.height / 2;
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                if (activeIndex === -1) {
                    activeIndex = index;
                } else {
                    const prevCenter = elements[activeIndex].getBoundingClientRect().top + elements[activeIndex].getBoundingClientRect().height / 2;
                    if (Math.abs(elCenter - viewportCenter) < Math.abs(prevCenter - viewportCenter)) {
                        activeIndex = index;
                    }
                }
            }
        });

        function setActiveTag(tagId) {
            const tags = document.querySelectorAll('.js-tag');
            tags.forEach(tag => {
                if (tag.getAttribute('data-tag-id') === tagId) {
                    tag.classList.add('active');
                } else {
                    tag.classList.remove('active');
                }
            });
        }

        items.forEach((item, index) => {
            if (index === activeIndex) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });

        navItems.forEach((navItem, index) => {
            if (index === activeIndex) {
                navItem.classList.add('active');

                const tagId = navItem.getAttribute('data-tag-id');
                if (tagId) {
                    setActiveTag(tagId);
                }
            } else {
                navItem.classList.remove('active');
            }
        });
    }

    function updateTicks() {
        if (ticks.length === 0) return;

        const rect = scrollElement.getBoundingClientRect();
        const scrollElementTop = rect.top;
        const scrollElementHeight = rect.height;
        const scrollProgress = Math.min(1, Math.max(0, -scrollElementTop / (scrollElementHeight - window.innerHeight)));
        const activeTick = scrollProgress * (ticks.length - 1);

        ticks.forEach((tick, index) => {
            const distance = Math.abs(index - activeTick);
            const scale = Math.max(0.15, 1 / (1 + distance * distance * 0.3));

            tick.style.transform = `scaleX(${scale})`;

            const closestTickIndex = Math.round(activeTick);
            if (index === closestTickIndex) {
                tick.classList.add('active');
            } else {
                tick.classList.remove('active');
            }
        });
    }

    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        lastScrollY = currentScrollY;

        // Rotator logic scoped to this element
        const rotators = scrollElement.querySelectorAll('.scroll-element__item__rotator img');
        rotators.forEach(r => {
            r.style.transform = `rotate(${window.scrollY * 0.038}deg)`;
        });

        updateActiveOnScroll();
        updateTicks();
    });

    window.addEventListener('resize', () => {
        updateActiveOnScroll();
        updateTicks();
    });

    // Initial call
    updateActiveOnScroll();
    updateTicks();

    // On click of nav item, scroll to corresponding element
    navItems.forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
            if (elements[index]) {
                elements[index].scrollIntoView({ behavior: 'smooth', block: 'center' });

                // check if there is a data-tag-id value
                const tagId = navItem.getAttribute('data-tag-id');
                if (tagId) {
                    setActiveTag(tagId);
                }
            }
        });
    });
});